import { render, staticRenderFns } from "./upgradeTip.vue?vue&type=template&id=05a8901a&scoped=true"
import script from "./upgradeTip.vue?vue&type=script&lang=js"
export * from "./upgradeTip.vue?vue&type=script&lang=js"
import style0 from "./upgradeTip.vue?vue&type=style&index=0&id=05a8901a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.35_css-loader@6.5.0_webpack@5.105.4_postcss@8._9ca5930b91b9e9e517a72aaa81c77ab9/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a8901a",
  null
  
)

export default component.exports